import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { NavDropdown,
         MenuItem,
         Media}             from 'react-bootstrap';
import LinkContainer        from '../../../container/LinkContainer';
import FotoPerfil           from '../../../container/renderFotoPerfil';
import { logout }           from '../../../actions/authenticActions';

class Menu_Perfil extends Component {

    constructor(props){
        super(props)
        this.handleSelect =  this.handleSelect.bind(this);
    }

    handleSelect(key) {
        this.props.logout();
    }

    render() {
        return (
            <NavDropdown 
                className = "hidden-xs NavDropdownNotificacao"
                
                id        = "basic-nav-dropdown"
                title     = {
                              <FotoPerfil 
                                width     = "35"
                                height    = "35"
                                className = "img-circle"
                                src       = {this.props.session.foto}/>
                            }>
            <LinkContainer to={this.props.menu.perfil.home}>
               <MenuItem className="tituloPerfil">
                 <Media>
                   <Media.Left>
                     <img width={40} height={40} className="img-circle" src={this.props.session.foto} alt="Image" />
                   </Media.Left>
                   <Media.Body>
                     <h5 className="media-heading">
                       {this.props.session.nome}
                     </h5>
                     <span>
                       {this.props.session.email}
                     </span>
                   </Media.Body>
                 </Media>
               </MenuItem>
            </LinkContainer>
            {this.props.config.userAluno === this.props.session.perfil ? 
              <LinkContainer to={this.props.menu.pontuacao}>
                <MenuItem>
                  <span className="glyphicon glyphicon-record"></span> 
                  <b>Pontuação</b>
                </MenuItem>
               </LinkContainer>:""}
             <LinkContainer to={this.props.menu.perfil.home}>
              <MenuItem><span className="glyphicon glyphicon-user"></span> <b>Perfil</b></MenuItem>
            </LinkContainer>
            <LinkContainer to="/login" onClick = {this.handleSelect}>
              <MenuItem><span className="glyphicon glyphicon-log-in"></span> <b>Sair</b></MenuItem>
            </LinkContainer>
           </NavDropdown>
        );
    }
}


function mapStateToProps(state){
    return {
             session : state.auth.session,
             menu    : state.configReducer.menu,
             config  : state.configReducer.config
            }
}
    
export default connect(mapStateToProps,{logout})(Menu_Perfil);



// WEBPACK FOOTER //
// ./src/components/professor/topo/menu_perfil.js